import {$body} from '../../../Constants';
import SwiperSlider from '../../../Elements/SwiperSlider';

/**
 * Variant Slider
 */
const VariantSlider = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		VARIANT_SLIDER: '.variants',
	};

	/**
	 * Variant Slider
	 *
	 * @class
	 * @augments SwiperSlider
	 */
	class VariantSlider extends SwiperSlider {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this.setOptions({
				slidesPerView: 4,
				grabCursor: true,
				spaceBetween: 30,
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				breakpoints: {
					640: {
						slidesPerView: 2
					}
				}
			});

			this._initialize();
		}
	}

	return VariantSlider._getElements($body.find(Selector.VARIANT_SLIDER), VariantSlider);
})();

export default VariantSlider;
